import AgoraRTC from 'agora-rtc-sdk-ng'
import * as M from 'materialize-css'
import UAParser from 'ua-parser-js'
import Bus from '@/assets/js/bus.js'
import $store from '@/store/index.js'
import i18n from '@/lang'

import * as $ from 'jquery'
export const screenShareResolutions = [
  {
    name: 'default',
    value: 'default'
  },
  {
    name: '480p_1',
    value: '480p_1'
  },
  {
    name: '720p_1',
    value: '720p_1'
  },
  {
    name: '1080p_1',
    value: '1080p_1'
  }
]

const parser = new UAParser()

const userAgentInfo = parser.getResult()

export const isSafari = () => {
  return (
    userAgentInfo.browser.name === 'Safari' ||
    userAgentInfo.browser.name === 'Mobile Safari'
  )
}

export const isCompatibleChrome = () => {
  if (userAgentInfo.browser.name === 'Chrome') {
    const major = +userAgentInfo.browser.major
    if (major >= 72) return true
  }
  return false
}

export const isFirefox = () => {
  return userAgentInfo.browser.name === 'Firefox'
}

function Toastify (options) {
  M.toast({ html: options.text, classes: options.classes })
}

export const Toast = {
  info: (msg) => {
    Toastify({
      text: msg,
      classes: 'info-toast'
    })
  },
  notice: (msg) => {
    Toastify({
      text: msg,
      classes: 'notice-toast'
    })
  },
  error: (msg) => {
    Toastify({
      text: msg,
      classes: 'error-toast'
    })
  }
}

export function validator (formData, fields) {
  const keys = Object.keys(formData)
  for (const key of keys) {
    if (fields.indexOf(key) != -1) {
      if (!formData[key]) {
        Toast.error('Please Enter ' + key)
        return false
      }
    }
  }
  return true
}

export function addView (id, show) {
  if (!$('#' + id)[0]) {
    $('<div/>', {
      id: 'remote_video_panel_' + id,
      class: 'video-view'
    }).appendTo('#video')

    $('<div/>', {
      id: 'remote_video_' + id,
      class: 'video-placeholder'
    }).appendTo('#remote_video_panel_' + id)

    $('<div/>', {
      id: 'remote_video_info_' + id,
      class: 'video-profile ' + (show ? '' : 'hide')
    }).appendTo('#remote_video_panel_' + id)

    $('<div/>', {
      id: 'video_autoplay_' + id,
      class: 'autoplay-fallback hide'
    }).appendTo('#remote_video_panel_' + id)
  }
}

export function removeView (id) {
  if ($('#remote_video_panel_' + id)[0]) {
    $('#remote_video_panel_' + id).remove()
  }
}
export function openPerimissionDialog (callback) {
  // 创建流，触发媒体设备权限申请
  const tempAudioStream = AgoraRTC.createStream({ audio: true, video: false })
  const tempVideoStream = AgoraRTC.createStream({ audio: false, video: true })
  const audioPermissionOK = new Promise(resolve => {
    tempAudioStream.init(() => resolve(null), (e) => resolve(e))
  })
  const videoPermissionOK = new Promise(resolve => {
    tempVideoStream.init(() => resolve(null), (e) => resolve(e))
  })

  Promise.all([audioPermissionOK, videoPermissionOK]).then(res => {
    // null null表示都有权限
    let hasAudio = true; let hasVideo = true
    if (res[0] !== null) {
      hasAudio = false
    }
    if (res[1] !== null) {
      hasVideo = false
    }
    const obj = {
      hasAudio: hasAudio,
      hasVideo: hasVideo
    }
    tempAudioStream.close()
    tempVideoStream.close()
    callback(obj)
  }, err => {
  })
}
export function judgeHasCamera (hasVideo, openCamera) {
  let cameraMsg = 1
  if (hasVideo) {
    cameraMsg = openCamera ? 1 : 2
  } else {
    cameraMsg = 3
  }
  return cameraMsg
}
export function getDevices () {
  // 先看是否可以获取到Devices，如果拿到是deviceId为空则申请打开权限
  const obj = {
    videoList: [],
    microList: [],
    videoLoaded: true,
    audioLoaded: true,
    selectMicroId: '',
    selectCameraId: '',
    hasVideo: false,
    hasAudio: false
  }
  // 判断当前是否有摄像头
  try {
    navigator.mediaDevices.getUserMedia({ video: true, audio: false })
    .then(res => {
      obj.hasVideo = true
      $store.state.hasVideo = true
    // Bus.$emit("hasVideo", obj.hasVideo); emit发送可能会导致顺序的问题，无法更新状态，调用后直接更新store值即可
    })
    .catch((error) => {
      $store.state.hasVideo = false
    })
  } catch (e) {
    $store.state.hasVideo = false
  }
  
   try {
    navigator.mediaDevices.getUserMedia({ video: false, audio: true })
    .then(res => {
      obj.hasAudio = true
      $store.state.hasAudio = true
    // Bus.$emit("hasAudio", obj.hasAudio);
    })
    .catch((error) => {
      $store.state.hasAudio = false
    })
   } catch (e) {
    $store.state.hasAudio = false
   }
  AgoraRTC.getDevices(devices => {
    if (devices.length > 0) {
      devices.forEach((item, index) => {
        if (item.kind === 'audioinput' && item.deviceId !== '') {
          if (item.deviceId === 'default') {
            obj.selectMicroId = item.deviceId
          }
          obj.microList.push(item)
        }
        if (item.kind === 'videoinput' && item.deviceId !== '') {
          if (obj.selectCameraId === '') {
            obj.selectCameraId = item.deviceId
          }
          obj.videoList.push(item)
        }
        if (item.deviceId === '') {
          if (item.kind === 'audioinput') {
            obj.audioLoaded = false
          } else {
            obj.videoLoaded = false
          }
        }
      })
    }
    Bus.$emit('initDevices', obj)
  }, err => {
  })
}

export function showDeviceTips (deviceType, val, devicesInfo) {
  let msg = ''
  const hasAvailableDevice = devicesInfo[`${deviceType}List`]?.length
  const errorMsg = devicesInfo[`${deviceType}Error`]
  if (errorMsg) {
    msg = i18n.t('operationBtn.deviceBlock', { deviceType: i18n.t(`operationBtn.${deviceType}`) })
  } else if (!hasAvailableDevice) {
    msg = i18n.t('common.noAvailableDevice', { deviceType: i18n.t(`operationBtn.${deviceType}`) })
  } else {
    msg = val ? i18n.t('operationBtn.off') + i18n.t(`operationBtn.${deviceType}`) : i18n.t('operationBtn.on') + i18n.t(`operationBtn.${deviceType}`)
  }
  return msg
}
